import React from 'react';
import {Field} from 'formik';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './inputText.scss';

const InputText = ({type, name, placeholder}) => (
  <Field name={name}>
    {({field}) => (
      <div className={classnames('input-text', {filled: field.value})}>
        <label htmlFor={name}>{placeholder}</label>
        <input id={name} type={type} placeholder={placeholder} {...field} />
        <div className="input-text-focus-line" />
      </div>
    )}
  </Field>
);

InputText.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'password']),
  name: PropTypes.string.isRequired,
};

InputText.defaultProps = {
  type: 'text',
};

export default InputText;
